export default "images/bounding box1.png";